import { render, staticRenderFns } from "./inflowMallRenovation.vue?vue&type=template&id=74a010a4&scoped=true"
import script from "./inflowMallRenovation.vue?vue&type=script&lang=js"
export * from "./inflowMallRenovation.vue?vue&type=script&lang=js"
import style0 from "./inflowMallRenovation.vue?vue&type=style&index=0&id=74a010a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a010a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a010a4')) {
      api.createRecord('74a010a4', component.options)
    } else {
      api.reload('74a010a4', component.options)
    }
    module.hot.accept("./inflowMallRenovation.vue?vue&type=template&id=74a010a4&scoped=true", function () {
      api.rerender('74a010a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/mallRenovation/inflowMallRenovation.vue"
export default component.exports